var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgencyCommissionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5049 21.039C15.5719 21.039 14.0049 19.472 14.0049 17.539C14.0049 15.606 15.5719 14.039 17.5049 14.039C19.4379 14.039 21.0049 15.606 21.0049 17.539C21.0049 19.472 19.4379 21.039 17.5049 21.039ZM17.5049 19.039C18.3333 19.039 19.0049 18.3675 19.0049 17.539C19.0049 16.7106 18.3333 16.039 17.5049 16.039C16.6765 16.039 16.0049 16.7106 16.0049 17.539C16.0049 18.3675 16.6765 19.039 17.5049 19.039ZM6.50488 10.039C4.57189 10.039 3.00488 8.47205 3.00488 6.53906C3.00488 4.60606 4.57189 3.03906 6.50488 3.03906C8.43788 3.03906 10.0049 4.60606 10.0049 6.53906C10.0049 8.47205 8.43788 10.039 6.50488 10.039ZM6.50488 8.03906C7.33331 8.03906 8.00488 7.36748 8.00488 6.53906C8.00488 5.71063 7.33331 5.03906 6.50488 5.03906C5.67646 5.03906 5.00488 5.71063 5.00488 6.53906C5.00488 7.36748 5.67646 8.03906 6.50488 8.03906ZM19.076 3.55378L20.4902 4.96799L4.93382 20.5243L3.5196 19.1101L19.076 3.55378Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyCommissionIcon);
export default __webpack_public_path__ + "static/media/AgencyCommissionIcon.fe87afca55f6c0c3d3052d5acd189e7c.svg";
export { ForwardRef as ReactComponent };